export default function containsForbidden(value) {
    var ALLOWED = /[^a-zA-Z0-9-=+_.?!&@# ]/;
    return ALLOWED.test(value);
}
